export default class LotSettingsStyles {
    static listStyles(theme = {}) {
        return ({
            root: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flex: 1,
            },
            header: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: theme.spacing(1),
                marginBottom: theme.spacing(2),
                [theme.breakpoints.down('sm')]: {
                    flexDirection: 'column',
                    alignItems: 'stretch',
                },
            },
            headerActionsWrap: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: theme.spacing(0.5),
                marginLeft: 'auto',
                [theme.breakpoints.down('sm')]: {
                    marginLeft: 0,
                    width: '100%',
                    alignItems: 'stretch',
                },
            },
            headerActions: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: theme.spacing(1),
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                    '& > *': {
                        flex: 1,
                    },
                    '& button': {
                        width: '100%',
                    },
                },
            },
            uploadFormatsHint: {
                fontSize: '11px',
                color: theme.palette.text.secondary,
                textAlign: 'right',
                [theme.breakpoints.down('sm')]: {
                    textAlign: 'left',
                },
            },
            box: {
                display: 'flex',
                marginBottom: theme.spacing(2),
                overflowY: 'auto',
                overflowX: 'hidden',
                '& > div > div > div': {
                    '& > label, & > input, & > div > input, & > div > label, & > div.select-bootstrap': {
                        fontSize: '13px',
                    },
                    '& > div.select-bootstrap > div': {
                        minHeight: 'initial',
                    },
                    '& > div.react-datepicker-wrapper input': {
                        fontSize: '13px',
                    },
                    '& .form-control': {
                        fontSize: '13px',
                    },
                    '& .select-bootstrap': {
                        fontSize: '13px',
                    },
                },
            },
            button: {
                color: theme.palette.text.white,
                marginRight: 0,
                whiteSpace: 'nowrap',
            },
            saveButton: {
                minWidth: '120px',
                backgroundColor: theme.palette.secondaryInfo.main,
                color: theme.palette.secondaryInfo.contrastText,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: theme.palette.secondaryInfo.dark,
                    boxShadow: 'none',
                },
            },
            editButton: {
                minWidth: '150px',
                backgroundColor: '#59A9FF',
                '&:hover': {
                    backgroundColor: '#4D91DB',
                },
            },
            content: {
                height: '100%',
                flex: 1,
                overflow: 'hidden',
            },
            checkedGreen: {
                color: theme.palette.success.main,
            },
            alignCheckBox: {
                marginBottom: '10px',
            },
            selectLot: {
                width: '250px',
                fontSize: '13px',
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
            },
            companyImage: {
                padding: '5px',
                border: '1px solid #ced4da',
                borderRadius: '0.25rem',
            },
            topSection: {
                position: 'relative',
                alignItems: 'flex-start',
            },
            imageContainer: {
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1.5),
                [theme.breakpoints.up('md')]: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    width: '50%',
                    maxWidth: '50%',
                    paddingLeft: theme.spacing(0.5),
                    paddingRight: theme.spacing(0.5),
                    boxSizing: 'border-box',
                },
            },
            mediaPanel: {
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(0.5),
                minHeight: 0,
                overflow: 'hidden',
            },
            mediaPanelPhoto: {
                flex: '1 1 60%',
            },
            mediaPanelLogo: {
                flex: '1 1 40%',
            },
            mediaPanelTitle: {
                fontSize: '13px',
                fontWeight: 600,
                color: theme.palette.text.primary,
                marginBottom: theme.spacing(0.5),
                flexShrink: 0,
            },
            mediaPanelBody: {
                position: 'relative',
                padding: theme.spacing(1),
                border: '1px solid #ced4da',
                borderRadius: '0.25rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.palette.background.paper,
                overflow: 'hidden',
                flex: 1,
                minHeight: 0,
                '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                },
            },
            mediaPlaceholder: {
                fontSize: '13px',
                color: theme.palette.text.secondary,
            },
            fieldRow: {
                display: 'flex',
                gap: theme.spacing(1.5),
                '& > *': {
                    flex: 1,
                    minWidth: 0,
                },
            },
            formColumn: {
                '& .form-group': {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            },
            formSection: {
                [theme.breakpoints.up('md')]: {
                    flexGrow: 0,
                    maxWidth: '50%',
                    flexBasis: '50%',
                },
            },
            border: {
                margin: '4px',
                paddingTop: '10px',
                border: '1px solid #ced4da',
                borderRadius: '0.25rem',
            },
            fees: {
                [theme.breakpoints.down('sm')]: {
                    width: '97.5%',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    '& > div': {
                        minWidth: '800px',
                    },
                },
            },
            customFee: {
                [theme.breakpoints.down('sm')]: {
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    '& > div:nth-child(1)': {
                        minWidth: '200px',
                    },
                    '& > div:nth-child(2)': {
                        minWidth: '400px',
                    },
                },
            },
            uploader: {
                display: 'none',
            },
            dragzone: {
                cursor: 'pointer',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            wrapperDate: {
                display: 'flex',
                flex: 1,
            },
            centerCheckbox: {
                marginTop: '35px',
            },
            centerCheckboxX: {
                marginTop: '2.25rem',
                marginBottom: '0px',
                backgroundColor: theme.palette.secondaryInfo.main,
            },
            centerCheckboxX2: {
                marginTop: '60px',
                marginBottom: '0px',
                backgroundColor: '#59A9FF',
            },
            centerCheckbox3: {
                marginTop: '50px',
            },
            topSpace: {
                marginTop: '10px',
            },
            inline: {
                display: 'inline-flex',
                alignItems: 'center',
                marginRight: '0.75rem',
            },
            inlineUserFieldCheckbox: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '5px',
            },
            inlineUserFieldTitle: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            label: {
                minWidth: '140px',
                marginTop: '5px',
            },
            leftSpace: {
                marginLeft: '0.75rem',
            },
            labelUserField: {
                maxWidth: '20px',
                marginTop: '5px',
                marginRight: '10px',
            },
        });
    }
}
